module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', [_c('p', {
    class: _vm.labelClass,
    style: ({
      width: _vm.$parent.labelWidth,
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "weui-cell__ft vux-cell-primary",
    class: {
      'vux-number-round': _vm.buttonStyle === 'round'
    },
    staticStyle: {
      "font-size": "0"
    }
  }, [_c('div', {
    style: ({
      float: _vm.align
    })
  }, [_c('a', {
    staticClass: "vux-number-selector vux-number-selector-sub",
    class: {
      'vux-number-disabled': _vm.disabledMin
    },
    on: {
      "click": _vm.sub
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "18",
      "height": "18"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.currentValue),
      expression: "currentValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "vux-number-input",
    style: ({
      width: _vm.width
    }),
    attrs: {
      "name": _vm.name,
      "readonly": !_vm.fillable,
      "pattern": "[0-9]*",
      "type": "number"
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "blur": [_vm.blur, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "vux-number-selector vux-number-selector-plus",
    class: {
      'vux-number-disabled': _vm.disabledMax
    },
    on: {
      "click": _vm.add
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "20",
      "height": "20"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readonly),
      expression: "readonly"
    }],
    staticClass: "weui-cell__ft vux-cell-primary"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1afc91f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/x-number/index.vue
// module id = 653
// module chunks = 1